import { SET_SELECTED_PRICING_LOAD } from '../actionTypes'

const initialState = null



export default (state=initialState,  payload) => {
    const loads = (payload.type === SET_SELECTED_PRICING_LOAD) ? payload.load || initialState : state

    return loads
}